import { Component, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Title, Meta }     from '@angular/platform-browser';

import { ItemPage } from '../item/item';

import { RestaurantProvider } from '../../providers/restaurant';
import { MenuProvider } from '../../providers/menu';
import { ItemProvider } from '../../providers/item';
import { SetupProvider } from '../../providers/setup';


@Component({
    selector: 'page-restaurant',
    templateUrl: './restaurant.html',
    styleUrls: ['./restaurant.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RestaurantPage {

	public rest: any;
	public menu: any;
	public types: any;
	private modal: any;

	constructor (
		protected restProv: RestaurantProvider,
		protected menuProv: MenuProvider,
		protected itemProv: ItemProvider,
		protected setupProv: SetupProvider,
  	private route: ActivatedRoute,
  	private router: Router,
  	private modalService: NgbModal,
  	private titleService: Title,
  	private metaService: Meta,
	) {
	}

	ngOnDestroy() {
		this.titleService.setTitle('FeastHood');
		this.metaService.removeTag('name="twitter:title"');
		if (this.modal != null) {
			this.modal = this.modal.dismiss();
		}
	}

	ngOnInit() {
		this.setupProv.get('dish', 'types').subscribe(data => { this.types = data });

	  this.route.paramMap
			.switchMap((params: ParamMap) => this.restProv.get(params.get('rid')))
			.subscribe((val) => {
				this.rest = val;
				this.titleService.setTitle( this.rest.name + ' | FeastHood');
				this.metaService.addTag({ name: 'twitter:title', content: this.rest.name });
				this.itemProv.list(this.rest.uid).combineLatest(this.menuProv.list(this.rest.uid, this.rest.key), (items: Array<any>, menus: Array<any>) => {

					items = items.filter(v => v.isActive);
					let nowt = (new Date()).getHours() * 60 + (new Date()).getMinutes();
					menus = menus.filter(v => {
							if (!v.settings || (v.settings.isActive && !v.settings.isScheduled))
									return true;
							if (!v.settings.isActive || !v.settings.days['day' + (new Date).getDay()])
									return false;
							let tmp: any;
							tmp = v.settings.timePeriod.from.split(':');
							let vtf = +tmp[0] * 60 + (+tmp[1]);
							tmp = v.settings.timePeriod.to.split(':');
							let vtt = +tmp[0] * 60 + (+tmp[1]);
							vtt = vtt == 0 ? 24*60 : vtt;
							if (!(nowt >= vtf && nowt <= vtt))
									return false;
							v.settings.timeRange = vtt - vtf;
							return true;
					}).sort((val1, val2) => {
							if (!val1.settings || !val1.settings.isScheduled)
									return 1;
							if (!val2.settings || !val2.settings.isScheduled)
									return -1;
							return val1.settings.timeRange == val2.settings.timeRange ? 0 : (val1.settings.timeRange < val2.settings.timeRange ? -1 : 1);
	        });
					let val2 = menus[0];
					let res = {
						categories: [],
						items: []
					};
					if (!!val2) {
						if (!!val2.categories) {
							val2.categories.map(val => {
								if (!!val.items) {
									let cat = {
										name: val.name,
										items: []
									};
									for (let key of val.items) {
										cat.items.push.apply(cat.items, items.filter(obj => obj.key == key));
									} 
									if (cat.items.length > 0)
										res.categories.push(cat);
								}
							});
						}
						if (!!val2.items) {
							for (let key of val2.items) {
								res.items.push.apply(res.items, items.filter(obj => obj.key == key));
							}
						}
					}
					return res;
				}).subscribe(data => {
					this.menu = data;
				});
			});
	}

  isIfrme(): boolean{
  	return this.route.snapshot.queryParams['iframe'] == 'true';
  }

	toItem(iid: any) {
		this.modal = this.modalService.open(ItemPage);
		this.modal.componentInstance.customIds(this.rest.uid, iid);
//		this.router.navigate(['/item', this.rest.uid, iid]);
	}

	isDesctop(): boolean {
		if (this.menu && (!this.menu.categories || this.menu.categories.length == 0))
			return true;
    let ua = navigator.userAgent;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua))
			return false;
		return true;
	}

}



// WEBPACK FOOTER //
// /Users/nikolay/Documents/GitHub/menu-web/src/app/pages/restaurant/restaurant.ts